<template>
  <div class="mb-2">
    <div class="b-form__container_type_flex">
      <checkbox class="b-checkbox" :id="`buyout-${currentAssetComponent.assetId}-${currentAssetComponentIndex}`" v-model="isBuyout">{{$t('CONTENT.assets.buyout')}}</checkbox>
      <dynamic-icon class="ml-1" v-tooltip="$t('CONTENT.hints.buyoutHint')" icon="question"></dynamic-icon>
    </div>
    <transition name="fade">
      <div class="my-4 ml-6" v-if="isBuyout">
        <h5 class="mb-2">{{$t('CONTENT.assets.options_spi')}}</h5>
        <div>
          <checkbox class="b-checkbox" :id="`is-buyout-${currentAssetComponent.assetId}-${currentAssetComponentIndex}`" v-model="buyoutIsSure">{{$t('CONTENT.assets.options_is_buyout')}}</checkbox>
        </div>
        <div class="row mt-4 px-0">
          <div class="col-2">
            <div class="b-form__container" data-cy="asset-component-quantity">
              <label>{{$t('CONTENT.assets.option_month_count')}}:</label>
              <numeric class="b-numeric" controls :min="0" v-model="buyoutMonthCount" :disabled="!buyoutIsSure || isReadOnlyField" @keypress="changeNumericValue($event)" @change="onChangeBuyoutMonthCount"></numeric>
            </div>
          </div>
          <div class="col-2">
            <div class="b-form__container">
              <label>{{$t('CONTENT.assets.option_buyout_date')}}:</label>
              <div class="is-manually">
                <div v-if="isManuallyBuyoutDate" class="is-manually-mark" :title="`${$t('CONTENT.isManuallyData')}`"></div>
                <datepicker class="b-datepicker" v-model="buyoutDate" :disabled="!buyoutIsSure || isReadOnlyField" :formatter="datepickerFormat" :disabled-date="endAssetComponentDate"></datepicker>
              </div>
            </div>
          </div>
        </div>
        <!--Данные платежа по выкупу-->
        <div class="my-8" v-if="buyoutIsSure">
          <div class="row mt-5">
            <div class="col-2">
              <div>
                <label>{{$t('CONTENT.payments.payment_currency_code')}}:</label>
                <cool-select :list="currencyCodes"
                             option-value="code"
                             option-text="name"
                             :placeholder="$t('CONTENT.choose')"
                             v-model="buyoutCurrencyCode"></cool-select>
              </div>
            </div>
            <div class="col-2">
              <div class="b-form__container">
                <label for="buyout-external-id">{{$t('CONTENT.external_id')}}:</label>
                <input
                  data-cy="buyout-external-id"
                  type="text"
                  id="buyout-external-id"
                  class="b-input"
                  name="buyout-external-id"
                  v-model.lazy="buyoutExternalId"
                />
              </div>
            </div>
          </div>
          <div class="mt-4">
            <div class="row mt-2 b-form__container_type_flex b-form__row_type_flex-end">
              <div class="col-2" data-cy="buyout-lease-rate">
                <label>{{$t('CONTENT.assets.redemption_value')}}:</label>
                <numeric class="b-numeric" controls :min="0" :max="1000000000000" v-model="buyoutLeaseRate"></numeric>
              </div>
              <div class="col-2">
                <div>
                  <label>{{$t('CONTENT.payments.payment_date')}}:</label>
                  <datepicker class="b-datepicker" v-model="buyoutPaymentDate" :formatter="datepickerFormat"></datepicker>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
	import dateConverter from "../../../../../utils/converters/date.converter";
	import BuyoutOption from "../../../../../models/contract/BuyoutOption";
	import DateWithoutTimeAPI from "../../../../../api/DateWithoutTimeAPI";
  import changeNumericValue from "../../../../../mixins/changeNumericValue";
  import datepickerFormat from '@/mixins/datepickerFormat.mixin';

	export default {
		props: {
      currentAssetComponent: {
				type: Object,
			},
      currencyCodes: {
        type: Array,
        required: true,
      },
      currentAssetComponentIndex: {
        type: Number,
      }
		},
		data() {
			return {
				buyoutMonthCount: null,
				isManuallyBuyoutDate: false,
				isReadOnlyField: false,
			}
		},
    mixins: [changeNumericValue, datepickerFormat],
    watch: {
			buyoutIsSure(val) {
				if(!val && this.isBuyout) {
					this.buyoutMonthCount = null;
          this.isManuallyBuyoutDate = false;
          this.$store.commit('assetComponentsPlugin/addBuyoutOption', {assetId: this.currentAssetComponent.assetId, assetComponent: this.currentAssetComponent, data: BuyoutOption.createNew()});
          this.changeBuyout();
        }
			},
      'currentAssetComponent.startDate'(val) {
        if(val !== null && this.buyoutMonthCount !== null) {
          this.onChangeBuyoutMonthCount(this.buyoutMonthCount);
        } else if(val === null && this.currentAssetComponent.buyout !== null) {
          this.updateBuyoutDate(null);
          this.buyoutMonthCount = null;
        }
      },
    },
		computed: {
			isBuyout: {
				get() {
					return this.currentAssetComponent.buyout !== null;
				},
				set(value) {
					if(value) {
            this.$store.commit('assetComponentsPlugin/addBuyoutOption', {assetId: this.currentAssetComponent.assetId, assetComponent: this.currentAssetComponent, data: BuyoutOption.createNew()});
						this.buyoutMonthCount = null;
						this.isManuallyBuyoutDate = false;
					} else {
            this.$store.commit('assetComponentsPlugin/addBuyoutOption', {assetId: this.currentAssetComponent.assetId, assetComponent: this.currentAssetComponent, data: null});

            this.changeBuyout();

            this.buyoutMonthCount = null;
						this.isManuallyBuyoutDate = false;
					}
				}
			},
			buyoutCurrencyCode: {
				get() {
				  if(this.currentAssetComponent.buyout.currencyCode !== null) {
				    return this.currentAssetComponent.buyout.currencyCode.toLowerCase();
          } else {
				    return null;
          }
        },
        set(newVal) {
          this.$store.commit('assetComponentsPlugin/updateBuyoutOption', {
            assetId: this.currentAssetComponent.assetId,
            name: 'currencyCode',
            assetComponent: this.currentAssetComponent,
            value: newVal.toUpperCase()
          });
          this.changeBuyout();
        }
      },
			buyoutIsSure: {
				get() {
					if(this.currentAssetComponent.buyout === null) {
						return false;
					} else {
						return this.currentAssetComponent.buyout.isSure;
					}
				},
				set(value) {
					if(value) {
            this.$store.commit('assetComponentsPlugin/addBuyoutOption', {assetId: this.currentAssetComponent.assetId, assetComponent: this.currentAssetComponent, data: BuyoutOption.createNew()});
						this.buyoutMonthCount = null;
						this.isManuallyBuyoutDate = false;
          }

          this.$store.commit('assetComponentsPlugin/updateBuyoutOption', {
            assetId: this.currentAssetComponent.assetId,
            assetComponent: this.currentAssetComponent,
            name: 'isSure',
            value: value
          });

          this.changeBuyout();
        }
			},
			buyoutDate: {
				get() {
					if(this.currentAssetComponent.buyout == null || this.currentAssetComponent.buyout.date == null) {
						return null;
					} else {
						return dateConverter.convertToDate(this.currentAssetComponent.buyout.date);
					}
				},
				set(newVal) {
          if (newVal !== null) {
            let buyoutDate = dateConverter.convertToString(newVal);
            this.updateBuyoutDate(buyoutDate);
            this.isManuallyBuyoutDate = true;
            this.buyoutMonthCount = null;
          } else {
            this.updateBuyoutDate(null);
            this.buyoutMonthCount = null;
            this.isManuallyBuyoutDate = false;
          }
        }
      },
			buyoutExternalId: {
				get() {
					if(this.currentAssetComponent.buyout === null || this.currentAssetComponent.buyout.externalId === null) {
						return null;
					} else {
						return this.currentAssetComponent.buyout.externalId;
					}
				},
				set(value) {
          this.$store.commit('assetComponentsPlugin/updateBuyoutOption', {
            assetId: this.currentAssetComponent.assetId,
            name: 'externalId',
            assetComponent: this.currentAssetComponent,
            value: value
          });
          this.changeBuyout();
        }
      },
			buyoutLeaseRate: {
				get() {
					if(this.currentAssetComponent.buyout === null || this.currentAssetComponent.buyout.rate === null) {
						return null;
					} else {
						return this.currentAssetComponent.buyout.rate;
					}
				},
				set(newVal) {
          this.$store.commit('assetComponentsPlugin/updateBuyoutOption', {
            assetId: this.currentAssetComponent.assetId,
            name: 'rate',
            assetComponent: this.currentAssetComponent,
            value: newVal
          });
          this.changeBuyout();
        }
      },
			buyoutPaymentDate: {
				get() {
					if(this.currentAssetComponent.buyout === null || this.currentAssetComponent.buyout.paymentDate === null) {
						return null;
					} else {
						return dateConverter.convertToDate(this.currentAssetComponent.buyout.paymentDate);
					}
				},
				set(newVal) {
          let buyoutPaymentDate = null;
				  if (newVal !== null) {
            buyoutPaymentDate = dateConverter.convertToString(newVal);
          }

          this.$store.commit('assetComponentsPlugin/updateBuyoutOption', {
            assetId: this.currentAssetComponent.assetId,
            name: 'paymentDate',
            assetComponent: this.currentAssetComponent,
            value: buyoutPaymentDate
          });

          this.changeBuyout();
        }
      }
		},
		methods: {
      endAssetComponentDate(date) {
        if(this.currentAssetComponent.extension !== null && this.currentAssetComponent.extension.date !== null) {
          return date < dateConverter.convertToDate(this.currentAssetComponent.extension.date);
        } else if(this.currentAssetComponent.termination !== null && this.currentAssetComponent.termination.date !== null) {
          return date < dateConverter.convertToDate(this.currentAssetComponent.termination.date);
        } else if(this.currentAssetComponent.endDate !== null) {
          return date < dateConverter.convertToDate(this.currentAssetComponent.endDate);
        }
      },
			async onChangeBuyoutMonthCount(newVal) {
				if (newVal !== 0) {
          this.isManuallyBuyoutDate = false;
          try {
            this.error = null;
            this.isReadOnlyField = true;

            if(this.currentAssetComponent.startDate != null && this.currentAssetComponent.startDate !== '') {
              const convertedCurrentAssetComponentStartDate = encodeURIComponent(this.currentAssetComponent.startDate);
              let newDate = await new DateWithoutTimeAPI().addMonths(convertedCurrentAssetComponentStartDate, newVal);
              this.updateBuyoutDate(newDate);
            }
            this.isReadOnlyField = false;
          } catch (e) {
            this.isReadOnlyField = false;
            this.error = e;
          }
        }
      },
			updateBuyoutDate(value) {
        this.$store.commit('assetComponentsPlugin/updateBuyoutOption', {
          assetId: this.currentAssetComponent.assetId,
          name: 'date',
          assetComponent: this.currentAssetComponent,
          value: value
        });
        this.changeBuyout();
      },
      changeBuyout() {
        this.$emit('changeBuyout');
      }
		}
	}
</script>
